import { OrderBaseView } from "../../../order/base";
import { Template } from "../../../../../../core/template/index";
import { FortumApp } from "../../../../../fortumApp";
import { View } from "../../../../../../core/view/index";
import { OrderLike } from "../../../../../db/models/decontamination/order";
import { OrderItemLike } from "../../../../../db/models/decontamination/orderItem";
import { OrderItemDetailViewData } from "../../detail/index";
import { SelectOptionData } from "../../../../../../core/view/data-bind/types/selectbox-base";
import MessageModal from "../../../../../../core/modals/message/index";
import { ModalColor } from "../../../../../../core/modal/index";
import { ClientAction } from "../../../../../synchronizer/index";
import ConfirmModal from "../../../../../../core/modals/confirm/index";
import DeconCleansingTypeUsage, { CleansingTypeUsageLike, CleansingInstanceLike } from "../../../../../db/models/decontamination/cleansingTypeusage";
import { MeasuringTypeLike, MeasuringType } from "../../../../../db/models/decontamination/index";
import { Measurement } from "../../../../../db/models/decontamination/measurement";
import OrderItemEditMeasurementModal, { OrderItemEditMeasurementModalData } from "../../modals/edit-measurement/index";

export default class OrderItemMeasuringView extends View
{
    public template = Template.lazy('/app/views/decontamination/orderItem/tab/measuring/index.html');
    public app: FortumApp;
    public data: OrderItemMeasurementsTabViewData;
    private addMeasuringTypeButton: HTMLButtonElement;

    constructor(data?: OrderItemMeasurementsTabViewData) 
    {
        super(data);
    }

    public beforeRender(): PromiseLike<void>
    {
        return super.beforeRender().then(() =>
        {
            this.data.Measurement = Measurement;
        }).then(() =>
        {

        });
    }

    private resolveCleansingInstanceIndex(cleansingInstance: CleansingInstanceLike)
    {
        return this.data.item.cleansing_instances.indexOf(this.data.item.cleansing_instances.find(o => o.id == cleansingInstance.id));
    }

    public afterRender(): PromiseLike<void>
    {        
        return super.afterRender();
    }

    private onAddButtonClick(e: MouseEvent, sender: HTMLButtonElement)
    {
        let data = <OrderItemEditMeasurementModalData>{
            item_id: this.data.item.id,
            isNew: true,
            id: null,
        };

        this.openModal(OrderItemEditMeasurementModal, sender, data, {
            tab: 'measuring'
        });
    }

    private onEditButtonClick(e: MouseEvent, sender: HTMLButtonElement)
    {
        this.helpers.setButtonEnabled(sender, false);
        let itemId = parseInt(sender.getAttribute('data-item-id'));
        Measurement.withAll(this.app.db, this.app.db.DeconMeasurement.where('id').equals(itemId)).then((instances) =>
        {
            this.openModal(OrderItemEditMeasurementModal, sender, instances[0], {
                tab: 'measuring'
            });
        });
    }

    private onRemoveButtonClick(e: MouseEvent, sender: HTMLButtonElement)
    {
        this.helpers.setButtonEnabled(sender, false);
        this.app.actions.confirmAndPush(new ConfirmModal({
            message: this.pgettext(
                'decontamination.OrderItem',
                'Are you sure you want to remove this measurement?'
            )
        }), {
            action: ClientAction.DECONTAMINATION.REMOVE_ORDER_ITEM_MEASUREMENT,
            data: {
                order_item_id: this.data.item.id,
                measurement_id: sender.getAttribute('data-item-id')
            }
        }, false).then(() =>
        {
            this.app.refreshCurrentView({tab: 'measuring'}).then(() =>
            {
                this.app.toasts.show(this.app.pgettext(
                    'decontamination.OrderItem',
                    'Successfully removed a measurement!'
                ));
            })
        }, () =>
        {
            this.helpers.setButtonEnabled(sender, true);
        });
    }
}

export interface OrderItemMeasurementsTabViewData extends OrderItemDetailViewData
{
    Measurement?: Object;
}
